import { listing } from '@adc/blueprint'
import { enums } from '@adc/sdk'
import { match } from 'ts-pattern'
import iconBlue from '../../images/dot_blue.svg'
import iconGreen from '../../images/dot_green.svg'
import iconPurple from '../../images/dot_purple.svg'
import iconGray from '../../images/dot_gray.svg'

const getAssetIcons = assetType =>
  match(assetType)
    .when(
      assetType => assetType === enums.AssetType.BankOwned,
      () => iconBlue
    )
    .when(
      assetType => assetType === enums.AssetType.Foreclosure,
      () => iconGreen
    )
    .when(
      assetType => assetType === enums.AssetType.ShortSale,
      () => iconPurple
    )
    .when(
      assetType => assetType === enums.AssetType.PrivateSeller,
      () => iconPurple
    )
    .otherwise(() => iconGray)

const getDisplayIndicator = targetListing => {
  const displayInfo = listing.utils.getDisplayIndicator(targetListing)
  displayInfo.iconSvg = getAssetIcons(
    targetListing.listing_configuration?.asset_type
  )
  return displayInfo
}

export default getDisplayIndicator
